// 간편접수 절대 URL — site 가 있으면 공사 안내문 QR 용 `?site=` 를 붙인다.
export const intakeUrl = (origin: string, slug: string, siteId?: string | null): string => {
  const base = `${origin.replace(/\/+$/, "")}/s/intake/${encodeURIComponent(slug)}`;
  return siteId ? `${base}?site=${encodeURIComponent(siteId)}` : base;
};

// 내려받기 파일명.
export const intakeQrFileName = (slug: string): string => `buildpy-intake-${slug}.svg`;

// PNG 내려받기 파일명 — 인쇄소·카톡 공유용.
export const intakeQrPngFileName = (slug: string): string => `buildpy-intake-${slug}.png`;

// 인쇄용 접수 안내문 경로.
export const INTAKE_PRINT_PATH = "/app/settings/intake/print";
